import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedNavItemProps {
  href: string;
  label: string;
  index: number;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export default function AnimatedNavItem({ href, label, index, onClick }: AnimatedNavItemProps) {
  return (
    <motion.a
      href={href}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.15,
        ease: "easeOut",
        delay: index * 0.03
      }}
      onClick={onClick}
      className="relative text-gray-600 hover:text-gray-900 transition-colors duration-200 group md:text-left text-center py-3 md:py-0"
    >
      {label}
      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full hidden md:block" />
    </motion.a>
  );
}